import { RestrictedDateDomain, RestrictedDateTransferType, } from "../types";
export const DefaultRestrictedDate = {
    date: "2021-01-01 00:00:00 -0500",
    domain: RestrictedDateDomain.Both,
    name: "New Year's Day",
    observed: "2021-01-01 00:00:00 -0500",
    transferAllowed: false,
    transferType: RestrictedDateTransferType.NotAllowed,
};
export const FederalRestrictedDate = {
    date: "2021-10-11 00:00:00 -0400",
    domain: RestrictedDateDomain.Federal,
    name: "Columbus Day",
    observed: "2021-10-11 00:00:00 -0400",
    transferAllowed: false,
    transferType: RestrictedDateTransferType.NotAllowed,
};
export const InvestRestrictedDate = {
    date: "2021-04-02 00:00:00 -0400",
    domain: RestrictedDateDomain.Invest,
    name: "Good Friday",
    observed: "2021-04-02 00:00:00 -0400",
    transferAllowed: false,
    transferType: RestrictedDateTransferType.NotAllowed,
};
export const EarlyCutoffRestrictedDate = {
    date: "2021-11-26 00:00:00 -0500",
    domain: RestrictedDateDomain.Invest,
    name: "Black Friday",
    observed: "2021-11-26 00:00:00 -0500",
    transferAllowed: true,
    transferType: RestrictedDateTransferType.Partial,
};
export const TaxDayRestrictedDate = {
    date: "2021-04-15 00:00:00 -0400",
    domain: RestrictedDateDomain.Both,
    name: "Tax Day",
    observed: "2021-05-17 00:00:00 -0400",
    transferAllowed: true,
    transferType: RestrictedDateTransferType.Allowed,
};
export const ObservedRestrictedDate = {
    date: "2021-07-04 00:00:00 -0400",
    domain: RestrictedDateDomain.Both,
    name: "Independence Day",
    observed: "2021-07-05 00:00:00 -0400",
    transferAllowed: false,
    transferType: RestrictedDateTransferType.NotAllowed,
};
export const WiresRestrictedDate = {
    date: "2021-12-24 00:00:00 -0500",
    domain: RestrictedDateDomain.Wires,
    name: "Christmas Eve",
    observed: "2021-12-24 00:00:00 -0500",
    transferAllowed: false,
    transferType: RestrictedDateTransferType.NotAllowed,
};
export const restrictedDates = {
    RestrictedDates: [
        DefaultRestrictedDate,
        FederalRestrictedDate,
        InvestRestrictedDate,
        EarlyCutoffRestrictedDate,
        TaxDayRestrictedDate,
        ObservedRestrictedDate,
        WiresRestrictedDate,
    ],
};
//# sourceMappingURL=index.js.map